import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { StoreOutputDto, StoreService, StoreTypeOutputDto, StoreTypeService } from 'src/generated_client';

@Component({
  selector: 'app-shop-type-management',
  templateUrl: './shop-type-management.component.html',
  styleUrls: ['./shop-type-management.component.css']
})

export class ShopTypeManagementComponent implements OnInit {

  displayedColumns: string[] = ['name', 'image', 'status', 'option'];
  allStoreTypes: StoreTypeOutputDto[] = [];
  allStores: StoreOutputDto[] = [];

  constructor(
    private router: Router,
    public storeTypeService: StoreTypeService,
    public storeService: StoreService,
    private snackBar: SnackBarService,
  ) { }

  async ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.storeTypeService.apiStoreTypeGetGet().subscribe(x => {
      this.allStoreTypes = x;
    });
  }

  changeStoreTypeStatus(id: number, status: boolean, name: string) {
    if (status) {
      this.storeService.apiStoreGetAllStoresGet().subscribe(x => {
        this.allStores = x;
        let result = this.allStores.some(store => store.dsStoreTypeName == name && store.isEnabled);
        if (result) {
          this.snackBar.openSnackBar('No se puede desactivar el tipo de comercio. Hay uno o más comercios de este tipo activos.', 'Aceptar');
        } else {
          this.storeTypeService.apiStoreTypePutDisablePut(id).subscribe(response => {
            this.router.navigate(['shop-type-management']);
            this.snackBar.openSnackBar('El tipo de comercio se desactivó correctamente', 'Aceptar')
          }, (err) => {
            this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
          })
        }
      });
    } else {
      this.storeTypeService.apiStoreTypePutEnablePut(id).subscribe(response => {
        this.router.navigate(['shop-type-management']);
        this.snackBar.openSnackBar('El tipo de comercio se activó correctamente', 'Aceptar')

      }, (err) => {
        this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
      })
    }
  }

  editShopType(id: number) {
    this.router.navigate(['edit-shop-type', id]);
  }

  addShopType() {
    this.router.navigate(['add-shop-type']);
  }

  deleteShopType(id: number, name: string) {
    this.storeService.apiStoreGetAllStoresGet().subscribe(x => {
      this.allStores = x;
      let result = this.allStores.some(store => store.dsStoreTypeName == name && store.isEnabled);
      if (result) {
        this.snackBar.openSnackBar('No se puede eliminar el tipo de comercio. Hay uno o más comercios de este tipo activos.', 'Aceptar');
      } else {
        this.storeTypeService.apiStoreTypeDeleteDelete(id).subscribe(response => {
          this.router.navigate(['shop-type-management']);
          this.snackBar.openSnackBar('El tipo de comercio fue eliminado','Aceptar')
        }, (err) => {
          this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
        })
      }
    });
  }
}
